import { IAssetTag, ITag } from '../../models/tag.interface';
import { Loadable, createDefaultLoadable } from '../../models';

export interface AssetTagEntry {
    assetTags: IAssetTag[];
    loading: boolean;
    error: Error | null;
}

export interface TagState extends Loadable {
    tags: ITag[];
    saving: Loadable;
    colours: string[];
    assetTagMap: Record<string, AssetTagEntry>;
}

export const initialTagState: TagState = {
    ...createDefaultLoadable(),
    tags: [],
    saving: createDefaultLoadable(),
    colours: [],
    assetTagMap: {},
};
